import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TradeClassEntity } from './trade-class.model';

@Injectable({
    providedIn: 'root'
})
export class TradeClassService {
    private httpClient = inject(HttpClient);

    get(subscriberKey: number) {
        return this.httpClient.get<TradeClassEntity[]>(`api/subscriber/${subscriberKey}/trade-classes`);
    }
}
